import * as React from "react";

export type Orientation = "horizontal" | "vertical";

const usePanelOrientation = () => {
  const [orientation, setOrientation] = React.useState<Orientation>("horizontal");

  useIsomorphicLayoutEffect(() => {
    // set initial value for react-reflex
    setOrientation(getCurrentOrientation());

    function handleResize() {
      const currentOrientation = getCurrentOrientation();

      setOrientation(currentOrientation);
    }

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return orientation;
};

const useIsomorphicLayoutEffect = typeof window !== "undefined" ? React.useLayoutEffect : React.useEffect;

const getCurrentOrientation = (): Orientation => {
  // Reading a --layout CSS variable to make sure that the --layout logic is controlled in a single place
  return window.getComputedStyle(document.documentElement).getPropertyValue("--layout") === "row"
    ? "vertical"
    : "horizontal";
};

export { usePanelOrientation };
